import type { ImageStaticContent } from '@core-api/presentation/types/response';
import { usePresentationContext } from '../../legacy-context/presentationContext';
import { ImagePresentation } from './ImagePresentation';

export function ImagePresentationDataHandler() {
  const { useQuestion, useConfig } = usePresentationContext();
  const { InteractiveCanvasComponents } = usePresentationContext();
  const { enableAnimations } = useConfig();

  const slide = useQuestion();
  const staticContent = slide.staticContent as ImageStaticContent;
  const interactiveContent = slide.interactiveContents[0];

  return (
    <ImagePresentation
      shouldAnimate={enableAnimations}
      title={slide.title}
      styledTitle={staticContent.styledTitle as Record<string, unknown>}
      label={staticContent.label}
      imageUrl={slide.images?.[0]?.presets.original?.url}
      isFullSizeImage={staticContent.imagePosition === 'background'}
      imageAltDescription={interactiveContent?.image?.altText}
      CanvasTitleArea={InteractiveCanvasComponents?.CanvasTitleArea}
    />
  );
}
